<span [class]="icon"></span><ng-content></ng-content>
